












import { Component, Vue, Prop } from 'vue-property-decorator';
import { biHT } from '@/business/bi';
import { EntryEnum } from '@/types/voucher';
import { FitWxPhonex } from '@tencent/wphk-ui';
@Component({
  components: {
    FitWxPhonex,
  },
})
export default class InvalidVoucherEntry extends Vue {
  @Prop({ default: '' }) public className;

  private get isInvalidCouponPage() {
    return this.$route.query.type === EntryEnum.INVALID;
  }
  private goToInvalidList() {
    biHT('wallet.cvlist.listpage.expired_click');
    this.$router.push({
      name: 'voucherlist',
      query: { type: EntryEnum.INVALID },
    });
  }
}
